<script setup lang="ts">
import { type ComponentPublicInstance } from 'vue';
import SidebarPanel from '@components/layout/org&panel&support/SidebarPanel.vue';
import PanelLayoutContainer from '@components/layout/org&panel&support/PanelLayoutContainer.vue';

const router = useRouter();
const authStore = useAuthStore();
const { loggedIn } = storeToRefs(authStore);
const { login } = useAuth();
const siteConfigs = useSiteConfigs();
const panelPage = ref<
    ComponentPublicInstance<
        {},
        {},
        {},
        {},
        {
            refresh?: () => void;
        }
    >
>();
definePageMeta({
    layout: 'panel',
});
onMounted(() => {
    if (!loggedIn.value) {
        nextTick(async () => {
            const isAuthenticated = await login({
                message: `برای استفاده از پنل لطفا وارد حساب کاربری خود شوید.`,
                rejectionText: 'صفحه اصلی',
            });
            if (!isAuthenticated) {
                setTimeout(() => router.push('/'), 1000);
            } else {
                panelPage.value?.refresh?.();
            }
        });
    } else {
        authStore.loadUser();
    }
});
</script>

<template>
    <div class="panel-wrapper">
        <div
            class="panel-img"
            :style="{ '--panel': `url(${siteConfigs.panelBack})` }"
        />
        <PanelLayoutContainer no-padding>
            <div class="panel-content">
                <div class="sidebar-container">
                    <SidebarPanel />
                </div>
                <div class="main-container">
                    <nuxt-page ref="panelPage" />
                </div>
            </div>
        </PanelLayoutContainer>
    </div>
</template>

<style scoped lang="scss">
.panel-content {
    display: flex;
    margin-top: -48px;
}
.sidebar-container {
    width: 25%;
    padding-left: 12px;
    flex-shrink: 0;
}
.main-container {
    flex: 1;
    padding-right: 12px;
    margin-top: 64px;
    max-width: 75%;
}
.panel-img {
    width: 100%;
    height: 270px;
    background-image: var(--panel);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

@media (max-width: $app-tablet-max-width) {
    .sidebar-container {
        display: none;
    }
    .main-container {
        max-width: 100%;
    }
}

@media (max-width: $app-mobile-max-width) {
    .panel-wrapper {
        display: block;
    }

    .panel-content {
        flex-direction: column;
        margin-top: 12px;
    }

    .main-container {
        padding: 0;
        margin-top: 8px;
    }

    .panel-img {
        display: none;
    }
}
</style>
